import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { userService } from '../_services';

export function PrivateRoute({ component: Component, ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) =>
                userService.isSessionEndedHoldActive()
                || localStorage.getItem('user')
                || sessionStorage.getItem('user') ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
                )
            }
        />
    );
}